import React from 'react'
import { connect } from 'react-redux'
import PopularAttractionActions from '../../Redux/PopularAttractionRedux'

class FormEdit extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      form: {
        attraction_id: props.detail.id,
        origin: props.detail.modifier_value,
        priority: props.detail.priority
      }
    }
  }

  _save = (event) => {
    event.preventDefault()
    const data = {
      id: this.props.detail.popularity_id,
      form: this.state.form
    }

    this.props.save(data)
    this.props.closeModal()
  }

  _valueChange = (event) => {
    let val = event.target.value
    if (parseInt(val, 10) > 1000) {
      val = 1000
    } else if (parseFloat(val) < 1) {
      val = 1
    }
    this.setState({ form: { ...this.state.form, priority: val } })
  }

  render () {
    const { attraction_id, origin, priority } = this.state.form

    return (
      <div className='section' style={{ width: '40vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>Edit Popular Attraction</h4>
        </div>
        <form onSubmit={(event) => this._save(event)}>
          <div className='form-group'>
            <label className='control-label'>Attraction Title</label>
            <input type='text' className='form-control' readOnly value={this.props.detail.title || '-'} />
          </div>
          <div className='form-group'>
            <label className='control-label'>Priority</label>
            <input type='number' min='1' className='form-control' value={this.state.form.priority} onChange={(event) => this._valueChange(event)} />
          </div>
          <div className='form-group text-right'>
            <button type='button' className='btn btn-secondary' onClick={() => this.props.closeModal()}>Cancel</button>
            <button type='submit' disabled={!attraction_id || !origin || !priority} className='btn btn-primary ml-2'>Save</button>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  attraction: state.attraction
})

const dispatchToProps = (dispatch) => ({
  save: (data) => dispatch(PopularAttractionActions.popularAttractionEditRequest(data))
})

export default connect(stateToProps, dispatchToProps)(FormEdit)



// WEBPACK FOOTER //
// ./src/Containers/PopularAttraction/FormEdit.js